import React from "react"

export default function About() {
    return(
        <div className="about-div" id="about">
            <h1>Explore</h1>
        </div>
    )
}